module.exports = __webpack_public_path__ + "static/media/zina-india-logo-negativo.fea5fe01.svg";